import { LearningSeriesType, LearningModuleType } from './types'

export const getModulePrice = (
  series: LearningSeriesType,
  module: LearningModuleType
): number | undefined =>
  series.subscription_settings?.available_as_module
    ? module.price ?? series.subscription_settings?.module_price
    : undefined
